import Logo from "./Logo";
import { scrollToSection } from "@/hooks/useLenis";

const LINKS = [
  { label: "Home", id: "#home" },
  { label: "Routes", id: "#routes" },
  { label: "About", id: "#about" },
];

export default function Footer() {
  return (
    <footer className="border-t border-forest-600/50 bg-forest-950 px-5 py-12 md:px-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 text-sm text-forest-muted md:flex-row">
        <div className="flex items-center gap-3">
          <Logo className="h-8 w-8" />
          <div>
            <p className="font-display text-cream">EcoRoute</p>
            <p className="text-xs">Escape your screen. Explore nature.</p>
          </div>
        </div>
        <nav className="flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`footer-${l.label.toLowerCase()}-link`}
              onClick={() => scrollToSection(l.id)}
              className="transition-colors hover:text-moss"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <p className="font-mono text-xs">© 2026 EcoRoute · Built for Hacktoberfest · MIT</p>
      </div>
    </footer>
  );
}
